import classNames from 'classnames'
import { t } from 'i18next'
import { Card } from 'primereact/card'
import { SelectButton } from 'primereact/selectbutton'
import { Tag } from 'primereact/tag'
import { ToggleButton } from 'primereact/togglebutton'
import React from 'react'
import {
  ApprenticeshipModule,
  ApprenticeshipModuleWithSemesters,
} from '../../../../../../model/apprenticeshipModule.model'
import { ApprenticeshipModuleType } from '../../../../../../model/enums/enums'
import { ModuleWithSemester } from '../../../../../../model/moduleWithSemester.model'
import { ModuleTypeTag } from '../../utils/ModuleTypeTag'

export const getModuleTypeIcon = (
  apprenticeshipModuleType: number | undefined
): string => {
  switch (apprenticeshipModuleType) {
    case ApprenticeshipModuleType.ProfessionalModule:
      return 'fa-solid fa-briefcase'
    case ApprenticeshipModuleType.SchoolSubject:
      return 'fa-solid fa-person-chalkboard'
    case ApprenticeshipModuleType.Matura:
      return 'fa-solid fa-graduation-cap'
    case ApprenticeshipModuleType.UEK:
      return 'fa-solid fa-building-columns'
    default:
      return 'fa-solid fa-question'
  }
}

export const getSemesterArray = (
  apprenticeshipDurationInSem: number | undefined
): number[] => {
  if (!apprenticeshipDurationInSem) {
    return []
  }
  const semesters = []

  for (let i = 1; i <= apprenticeshipDurationInSem; i++) {
    semesters.push(i)
  }

  return semesters
}

export const ModuleTags = (props: {
  module: ApprenticeshipModule
}): JSX.Element => {
  return (
    <>
      <Tag className={'mr-2 light-blue-tag'}>
        {t<string>('core.education.bivo')} {props.module.bivo}
      </Tag>
      <Tag className={'mr-2 light-gray-tag'}>
        {t<string>('core.education.version_short')} {props.module.version}
      </Tag>
      <Tag className={'mr-2 light-gray-tag'}>
        {t<string>('core.education.release_year_short')}{' '}
        {props.module.year_of_release}
      </Tag>
    </>
  )
}

export const ModulePlanItemTemplate = (props: {
  module: ApprenticeshipModule
}) => {
  return (
    <Card
      className={classNames(
        { 'inactive-card': props.module.is_active === 0 },
        ' p-0 m-0'
      )}
      key={props.module.apprenticeship_module_id}
    >
      <div className={'w-full align-items-center inline-flex flex-wrap'}>
        <div className={'p-0 m-0 mr-1 col-1'}>
          <b>{props.module.module_key}</b>
        </div>
        <div className={'col'}>
          <span>{props.module.description}</span>
        </div>
        <div className={'m-0 p-0 col-4 inline-flex flex-wrap'}>
          {props.module.id_apprenticeship_module_type && (
            <div className={'col-12 m-0 p-0'}>
              <ModuleTypeTag
                moduleType={props.module.id_apprenticeship_module_type}
              />
            </div>
          )}
          <div className={'col-12 m-0 p-0'}>
            <ModuleTags module={props.module} />
          </div>
        </div>
      </div>
    </Card>
  )
}

export const ModulePlanItemTemplateWithSemester = (props: {
  module: ApprenticeshipModuleWithSemesters
  apprenticeshipDurationInSem: number
  setModulesWithSemester: (
    modulesWithSemester: (
      prevState: ModuleWithSemester[]
    ) => ModuleWithSemester[]
  ) => void
}) => {
  return (
    <Card
      className={classNames(
        { 'inactive-card': props.module.is_active === 0 },
        '  '
      )}
      key={props.module.apprenticeship_module_id}
    >
      <div className={'w-full align-items-center inline-flex flex-wrap'}>
        <div className={'p-0 m-0 col-1 mr-1'}>
          <b>{props.module.module_key}</b>
        </div>
        <div className={'col'}>
          <span>{props.module.description}</span>
        </div>
        <div className={'p-0 m-0 col-4 inline-flex flex-wrap'}>
          {props.module.id_apprenticeship_module_type && (
            <div className={'p-0 m-0 col-12'}>
              <ModuleTypeTag
                moduleType={props.module.id_apprenticeship_module_type}
              />
            </div>
          )}
          <div className={'col-12 p-0 m-0 '}>
            <ModuleTags module={props.module} />
          </div>
        </div>
        <div
          className={
            'col-12 p-0 m-0 mt-2 inline-flex align-items-center justify-content-end'
          }
        >
          <span className={'mr-2'}>
            {t<string>('core.education.semester')}:
          </span>
          <SelectButton
            key={'select_' + props.module.apprenticeship_module_id}
            className={'mr-2'}
            value={props.module.semesters}
            type={'button'}
            options={getSemesterArray(props.apprenticeshipDurationInSem)}
            multiple
            onChange={(e) => {
              console.log(e.target.value)

              if (props.module) {
                console.log(e.target.value)
                props.module.semesters = e.target.value
                //props.setModulesWithSemester((prevState: any[]) => [...prevState, moduleWithSemester])
              }
            }}
          />

          <ToggleButton
            key={'toggle_' + props.module.apprenticeship_module_id}
            checked={
              props.module?.semesters && props.module.semesters.length > 0
            }
            type={'button'}
            offLabel={t<string>('core.education.select_all')}
            onLabel={t<string>('core.education.unselect_all')}
            onChange={() => {
              console.log('test')
              if (props.module.semesters?.length > 0) {
                console.log('removing all semesters')
                props.module.semesters = []
              } else {
                console.log('adding all semesters')
                props.module.semesters = getSemesterArray(
                  props.apprenticeshipDurationInSem
                )
              }
              props.setModulesWithSemester((prevState: any[]) => [
                ...prevState,
                props.module,
              ])
            }}
          />
        </div>
      </div>
    </Card>
  )
}